
import Input from "../Input";
import Output from "../Output";
import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';

function ArabMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Arab magyar fordító</title>
                <meta name='description' content="Ingyenes arab magyar fordító szavakra, kifejezésekre, mondatokra és teljes szövegekre egyaránt." />
                <meta title="Arab magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/arab-magyar-fordito" />
            </Helmet>
            <h1>Arab magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <h2>Az arab nyelvről</h2>

                <p>Az arab egy sémi nyelv, amelyet emberek milliói beszélnek a Közel-Keleten, Észak-Afrikában és a világ más részein. Az Egyesült Nemzetek hat hivatalos nyelvének egyike, és jelentős kulturális és vallási jelentőséggel bír. Az alábbiakban az arab nyelv általános áttekintése következik:</p>

                <p><b>Történelmi jelentősége</b>: Az arab nyelv gazdag, több mint 1500 éves történelemmel rendelkezik. Az Arab-félszigetről származik, és az iszlám 7. századi megjelenésével vált ismertté. A Korán, az iszlám szent könyve arabul íródott, így a nyelv mélyen összefonódott az iszlám kultúrával és civilizációval.</p>

                <p><b>Nyelvi osztályozás</b>: Az arab a sémi nyelvcsaládba tartozik, amelybe a héber, az amhara és az arámi is beletartozik. A sémi nyelvcsaládon belül a közép-sémi nyelvek közé sorolják, más kiemelkedő nyelvváltozatokkal együtt, mint például a modern standard arab, a klasszikus arab és a különböző arab dialektusok.</p>

                <p><b>Diglosszia</b>: Az arab nyelv egy egyedülálló nyelvi jelenséget mutat, amelyet diglossziának neveznek. A diglosszia a nyelv két különböző formájának együttes létezésére utal: A klasszikus arab (Fusha) és a különböző beszélt dialektusok (Ammiya). A klasszikus arabot hivatalos és irodalmi kontextusban használják, például vallási szövegekben, irodalomban, médiában és hivatalos beszédekben. A beszélt dialektusok viszont az egyes arab országokban és régiókban eltérőek, de közös vonásaik és szókincsük van.</p>

                <p><b>Arab írás</b>: Az arab írást jobbról balra írják, és 28 betűből áll. Ez egy kurzív írás, ami azt jelenti, hogy a betűk írás közben összekapcsolódnak. Az arab írás hatással volt más nyelvek, például a perzsa, az urdu és a kurd írásrendszerére. Az írás esztétikai szépségéről híres, és az iszlám művészet különböző formáiban használták kalligráfiához.</p>

                <p><b>Nyelvi jellemzők</b>: Az arabot összetett nyelvtani szerkezet jellemzi. Három mássalhangzóból álló gyökrendszerrel rendelkezik, ahol a szavakat úgy képezik, hogy a gyökhöz mintákat és magánhangzókat adnak hozzá. Az arab nyelvtanban előfordulnak esetvégződések, kettős alakok és az igekötők gazdag rendszere is. A nyelvnek hatalmas szókincse van, számos arabból származó szót használnak más nyelvekben, különösen a tudomány, a matematika és a filozófia területén.</p>

                <p><b>Regionális nyelvjárások</b>: Az arab nyelvjárások régiónként jelentősen eltérnek egymástól. A történelmi, kulturális és földrajzi hatásoknak köszönhetően az idők során alakultak ki. Néhány jól ismert dialektus az egyiptomi arab, a levantei arab, az Öböl-arab és a maghrebi arab. A nyelvjárásoknak gyakran egyedi szókincsük, kiejtésük és nyelvtani jellemzőik vannak, ami néha kihívást jelenthet a különböző nyelvjárások beszélői közötti kommunikációban.</p>



                <p><b>Globális befolyás</b>: Az arab nyelv jelentős hatást gyakorolt más nyelvekre és kultúrákra. Az iszlám terjedése révén az arab szavakat és fogalmakat számos nyelv átvette, különösen az iszlám világban. Emellett az arab irodalom, költészet és tudományos hozzájárulások döntő szerepet játszottak az emberi tudás és kulturális örökség alakításában.</p>

                <p>Az arab nyelv ma is élénk és fejlődő nyelv. Világszerte emberek milliói számára szolgál kommunikációs, kulturális kifejezőeszközként és vallási gyakorlatként. Nyelvi gazdagsága, történelmi jelentősége és változatos dialektusai teszik az arab nyelvet olyan lenyűgöző nyelvvé, amely továbbra is magával ragadja a tanulókat és a kutatókat egyaránt.</p>
            </section>
        </>

    )
}

export default ArabMagyar;